import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { ITypeOfProduct } from '../../model/type-of-product.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class TypeOfProductService {
  async getTypeOfProducts(): Promise<ITypeOfProduct[]> {
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.TypeOfProduct.TypeOfProducts,
      {},
    );
  }
}
